import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatMessageDefaultVariants = {
  "role": "assistant",
  "density": "balanced",
  "grouping": "single",
  "state": "idle"
}
const chatMessageCompoundVariants = [
  {
    "role": "user",
    "grouping": "first",
    "css": {
      "content": {
        "borderBottomRightRadius": "4"
      }
    }
  },
  {
    "role": "user",
    "grouping": "middle",
    "css": {
      "content": {
        "borderTopRightRadius": "4",
        "borderBottomRightRadius": "4"
      }
    }
  },
  {
    "role": "user",
    "grouping": "last",
    "css": {
      "content": {
        "borderTopRightRadius": "4"
      }
    }
  }
]

const chatMessageSlotNames = [
  [
    "root",
    "chatMessage__root"
  ],
  [
    "content",
    "chatMessage__content"
  ],
  [
    "header",
    "chatMessage__header"
  ],
  [
    "senderName",
    "chatMessage__senderName"
  ],
  [
    "meta",
    "chatMessage__meta"
  ]
]
const chatMessageSlotFns = /* @__PURE__ */ chatMessageSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatMessageDefaultVariants, getSlotCompoundVariant(chatMessageCompoundVariants, slotName))])

const chatMessageFn = memo((props = {}) => {
  return Object.fromEntries(chatMessageSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatMessageVariantKeys = [
  "role",
  "density",
  "grouping",
  "state"
]
const getVariantProps = (variants) => ({ ...chatMessageDefaultVariants, ...compact(variants) })

export const chatMessage = /* @__PURE__ */ Object.assign(chatMessageFn, {
  __recipe__: false,
  __name__: 'chatMessage',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatMessageVariantKeys,
  variantMap: {
  "role": [
    "user",
    "assistant"
  ],
  "density": [
    "compact",
    "balanced",
    "spacious"
  ],
  "grouping": [
    "single",
    "first",
    "middle",
    "last"
  ],
  "state": [
    "idle",
    "loading",
    "failed"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chatMessageVariantKeys)
  },
  getVariantProps
})